// extracted by mini-css-extract-plugin
export default {"navigationbar":"NavigationBar_navigationbar__WGYFy","hamburgermenu":"NavigationBar_hamburgermenu__cBi9Z","hamburgercontent":"NavigationBar_hamburgercontent__VRu5B"};